export const accountingConstants = {
  GET_COST_CENTERS: "GET_ACCOUNTING_COST_CENTERS",
  GET_CUSTOM_SEGMENTS: "GET_CUSTOM_SEGMENTS",
  GET_LIST_ITEMS: "GET_ACCOUNTING_LIST_ITEMS",
  GET_LOCATIONS: "GET_ACCOUNTING_LOCATIONS",
  GET_NUMBERING_FLOWS: "GET_ACCOUNTING_NUMBERING_FLOWS",
  GET_EXPENSE_CATEGORIES: "GET_ACCOUNTING_EXPENSE_CATEGORIES",
  GET_TAX_CODES: "GET_ACCOUNTING_TAX_CODES",
  GET_VENDOR_EXPENSE_ACCOUNTS: "GET_ACCOUNTING_VENDOR_EXPENSE_ACCOUNTS",
  GET_CREDIT_ACCOUNTS: "GET_ACCOUNTING_CREDIT_ACCOUNTS",
  GET_ACCOUNTING_FIELDS: "GET_ACCOUNTING_FIELDS",
  GET_COMPANY_SETTINGS: "GET_ACCOUNTING_COMPANY_SETTINGS",
  CLEAR_ACCOUNTING_DATA: "CLEAR_ACCOUNTING_DATA",
};
